"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Field = exports.getErrorMessage = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var utils_1 = require("utils");
var Error_1 = require("./Error");
var getErrorMessage = function (_a) {
    var _b;
    var name = _a.name, errorMessage = _a.errorMessage, errors = _a.errors;
    return errorMessage !== null && errorMessage !== void 0 ? errorMessage : (_b = (errors !== null && errors !== void 0 ? errors : {})[name]) === null || _b === void 0 ? void 0 : _b.message;
};
exports.getErrorMessage = getErrorMessage;
var CONTAINER_STYLES = "flex flex-col";
var ICON_WRAPPER_STYLES = "absolute inset-y-0 flex text-contentAreaBorder";
var ICON_STYLES = "m-auto text-gray-500";
var WRAPPER_STYLES = "relative flex flex-grow flex-wrap";
var REQUIRED_STYLES = "text-sorbus-default text-xs mx-2 my-auto";
var getGrowStyle = function (grow) { return (grow ? "flex-grow" : ""); };
var getDisabledStyle = function (disabled) { return (disabled ? "opacity-75" : ""); };
var getIconPositionIf = function (searchField) {
    return searchField ? "left-0 ml-3" : "right-0 mr-3";
};
var Field = function (_a) {
    var label = _a.label, htmlFor = _a.htmlFor, name = _a.name, className = _a.className, labelClassName = _a.labelClassName, required = _a.required, icon = _a.icon, errorMessage = _a.errorMessage, grow = _a.grow, children = _a.children, disabled = _a.disabled, searchField = _a.searchField;
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, utils_1.concatStyles)([
            CONTAINER_STYLES,
            getGrowStyle(grow),
            getDisabledStyle(disabled),
            className,
        ]) }, { children: [(0, jsx_runtime_1.jsxs)("label", __assign({ htmlFor: htmlFor !== null && htmlFor !== void 0 ? htmlFor : name, className: (0, utils_1.concatStyles)("flex", labelClassName) }, { children: [label, " ", required && ((0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faAsterisk, className: REQUIRED_STYLES }, void 0))] }), void 0), (0, jsx_runtime_1.jsxs)("div", __assign({ className: WRAPPER_STYLES }, { children: [children, icon ? ((0, jsx_runtime_1.jsx)("span", __assign({ className: (0, utils_1.concatStyles)([
                            ICON_WRAPPER_STYLES,
                            getIconPositionIf(searchField),
                        ]) }, { children: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: icon, className: ICON_STYLES }, void 0) }), void 0)) : ((0, jsx_runtime_1.jsx)("span", {}, void 0)), errorMessage ? (0, jsx_runtime_1.jsx)(Error_1.Error, { children: errorMessage }, void 0) : null] }), void 0)] }), void 0));
};
exports.Field = Field;
exports.Field.displayName = "Form.Field";
